import { Component, OnInit } from '@angular/core';

interface BlogArticleMin {
  title: string;
  content: string;
  author: string;
  authorImage: string;
  publishDate: Date;
  tags: string[];
}

@Component({
  selector: 'app-article-link',
  templateUrl: './article-link.component.html',
  styleUrls: ['./article-link.component.css']
})
export class ArticleLinkComponent implements OnInit {

  
  article: BlogArticleMin = {
    title: 'Sample Blog Article',
    content: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
              Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.`,
    author: 'John Doe',
    authorImage: 'https://via.placeholder.com/150',
    publishDate: new Date(),
    tags: ['Angular', 'Web Development', 'Programming']
  };

  constructor() { }

  ngOnInit(): void {
  }

}